module.exports = __webpack_public_path__ + "img/gamma_background - small.c5eaaf16.png";